/*=========================================================================================
  File Name: moduleUnit.js
  Description: Units Module
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from "./moduleKitchenState";
import mutations from "./moduleKitchenMutations";
import actions from "./moduleKitchenActions";
import getters from "./moduleKitchenGetters";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
